import { msg } from "@lingui/core/macro";
import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { MeetingDetailPage } from "@/features/domain/components/meeting-detail-page";
import { useI18n } from "@/providers/i18n-provider";

function MeetingDetailRoutePage() {
  const { t } = useI18n();
  const params = useParams({ from: "/_app/meetings/$meetingId" });
  return (
    <AuthPlaceholder title={t(msg`Meeting`)} description={t(msg`Sign in to see this meeting.`)}>
      <PageContainer maxWidth="3xl">
        <MeetingDetailPage meetingId={params().meetingId} />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const meetingDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/meetings/$meetingId",
  component: MeetingDetailRoutePage,
});
